// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/services/v1/debug_service.proto (package thru.services.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_client } from "../../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_thru_common_v1_consensus } from "../../common/v1/consensus_pb";
import { file_thru_common_v1_filters } from "../../common/v1/filters_pb";
import { file_thru_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Pubkey, Signature } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { AccountMeta } from "../../core/v1/account_pb";
import { file_thru_core_v1_account } from "../../core/v1/account_pb";
import { file_thru_core_v1_block } from "../../core/v1/block_pb";
import { file_thru_core_v1_state } from "../../core/v1/state_pb";
import type { Transaction } from "../../core/v1/transaction_pb";
import { file_thru_core_v1_transaction } from "../../core/v1/transaction_pb";
import { file_thru_core_v1_types } from "../../core/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/services/v1/debug_service.proto.
 */
export const file_thru_services_v1_debug_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_protobuf_timestamp, file_thru_common_v1_consensus, file_thru_common_v1_filters, file_thru_common_v1_pagination, file_thru_common_v1_primitives, file_thru_core_v1_account, file_thru_core_v1_block, file_thru_core_v1_state, file_thru_core_v1_transaction, file_thru_core_v1_types]);

/**
 * CallFrame represents a single shadow stack frame from the VM.
 *
 * @generated from message thru.services.v1.CallFrame
 */
export type CallFrame = Message<"thru.services.v1.CallFrame"> & {
  /**
   * @generated from field: uint32 program_acc_idx = 1;
   */
  programAccIdx: number;

  /**
   * @generated from field: uint64 program_counter = 2;
   */
  programCounter: bigint;

  /**
   * @generated from field: uint64 stack_pointer = 3;
   */
  stackPointer: bigint;

  /**
   * @generated from field: repeated uint64 saved_registers = 4;
   */
  savedRegisters: bigint[];

  /**
   * Up to 1024 bytes above sp
   *
   * @generated from field: bytes stack_window = 5;
   */
  stackWindow: Uint8Array;

  /**
   * Virtual address of first byte (== stack_pointer)
   *
   * @generated from field: uint64 stack_window_base = 6;
   */
  stackWindowBase: bigint;
};

/**
 * Describes the message thru.services.v1.CallFrame.
 * Use `create(CallFrameSchema)` to create a new message.
 */
export const CallFrameSchema: GenMessage<CallFrame> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 0);

/**
 * MemoryPage represents a single allocated page of VM memory.
 *
 * @generated from message thru.services.v1.MemoryPage
 */
export type MemoryPage = Message<"thru.services.v1.MemoryPage"> & {
  /**
   * Index within the segment's page array
   *
   * @generated from field: uint32 page_index = 1;
   */
  pageIndex: number;

  /**
   * Page contents (4096 bytes)
   *
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;
};

/**
 * Describes the message thru.services.v1.MemoryPage.
 * Use `create(MemoryPageSchema)` to create a new message.
 */
export const MemoryPageSchema: GenMessage<MemoryPage> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 1);

/**
 * MemorySegment represents all allocated pages of a VM memory segment.
 *
 * @generated from message thru.services.v1.MemorySegment
 */
export type MemorySegment = Message<"thru.services.v1.MemorySegment"> & {
  /**
   * VM segment type (5=stack, 7=heap)
   *
   * @generated from field: uint32 segment_type = 1;
   */
  segmentType: number;

  /**
   * Total virtual size of segment in bytes
   *
   * @generated from field: uint64 segment_size = 2;
   */
  segmentSize: bigint;

  /**
   * @generated from field: repeated thru.services.v1.MemoryPage pages = 3;
   */
  pages: MemoryPage[];
};

/**
 * Describes the message thru.services.v1.MemorySegment.
 * Use `create(MemorySegmentSchema)` to create a new message.
 */
export const MemorySegmentSchema: GenMessage<MemorySegment> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 2);

/**
 * VmExecutionDetails contains detailed VM state after execution.
 *
 * @generated from message thru.services.v1.VmExecutionDetails
 */
export type VmExecutionDetails = Message<"thru.services.v1.VmExecutionDetails"> & {
  /**
   * @generated from field: uint64 execution_code = 1;
   */
  executionCode: bigint;

  /**
   * @generated from field: uint64 user_error_code = 2;
   */
  userErrorCode: bigint;

  /**
   * @generated from field: uint64 compute_units_consumed = 3;
   */
  computeUnitsConsumed: bigint;

  /**
   * @generated from field: uint64 state_units_consumed = 4;
   */
  stateUnitsConsumed: bigint;

  /**
   * @generated from field: uint64 pages_used = 5;
   */
  pagesUsed: bigint;

  /**
   * @generated from field: uint64 program_counter = 6;
   */
  programCounter: bigint;

  /**
   * @generated from field: uint64 instruction_counter = 7;
   */
  instructionCounter: bigint;

  /**
   * @generated from field: thru.services.v1.VmFaultCode fault_code = 8;
   */
  faultCode: VmFaultCode;

  /**
   * @generated from field: uint64 segv_vaddr = 9;
   */
  segvVaddr: bigint;

  /**
   * @generated from field: uint64 segv_size = 10;
   */
  segvSize: bigint;

  /**
   * @generated from field: bool segv_write = 11;
   */
  segvWrite: boolean;

  /**
   * @generated from field: repeated uint64 registers = 12;
   */
  registers: bigint[];

  /**
   * @generated from field: uint64 call_depth = 13;
   */
  callDepth: bigint;

  /**
   * @generated from field: uint64 max_call_depth = 14;
   */
  maxCallDepth: bigint;

  /**
   * @generated from field: repeated thru.services.v1.CallFrame call_frames = 15;
   */
  callFrames: CallFrame[];
};

/**
 * Describes the message thru.services.v1.VmExecutionDetails.
 * Use `create(VmExecutionDetailsSchema)` to create a new message.
 */
export const VmExecutionDetailsSchema: GenMessage<VmExecutionDetails> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 3);

/**
 * AccountSnapshot represents the state of an account at a point in time.
 *
 * @generated from message thru.services.v1.AccountSnapshot
 */
export type AccountSnapshot = Message<"thru.services.v1.AccountSnapshot"> & {
  /**
   * @generated from field: thru.common.v1.Pubkey address = 1;
   */
  address?: Pubkey | undefined;

  /**
   * @generated from field: thru.core.v1.AccountMeta meta = 2;
   */
  meta?: AccountMeta | undefined;

  /**
   * @generated from field: optional bytes data = 3;
   */
  data?: Uint8Array | undefined;

  /**
   * @generated from field: bool exists = 4;
   */
  exists: boolean;
};

/**
 * Describes the message thru.services.v1.AccountSnapshot.
 * Use `create(AccountSnapshotSchema)` to create a new message.
 */
export const AccountSnapshotSchema: GenMessage<AccountSnapshot> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 4);

/**
 * DebugReExecuteRequest is a request to re-execute a transaction in simulated environment.
 *
 * @generated from message thru.services.v1.DebugReExecuteRequest
 */
export type DebugReExecuteRequest = Message<"thru.services.v1.DebugReExecuteRequest"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: bool include_state_before = 2;
   */
  includeStateBefore: boolean;

  /**
   * @generated from field: bool include_state_after = 3;
   */
  includeStateAfter: boolean;

  /**
   * @generated from field: bool include_account_data = 4;
   */
  includeAccountData: boolean;

  /**
   * Return all allocated stack+heap pages
   *
   * @generated from field: bool include_memory_dump = 5;
   */
  includeMemoryDump: boolean;
};

/**
 * Describes the message thru.services.v1.DebugReExecuteRequest.
 * Use `create(DebugReExecuteRequestSchema)` to create a new message.
 */
export const DebugReExecuteRequestSchema: GenMessage<DebugReExecuteRequest> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 5);

/**
 * DebugReExecuteResponse is a response from the debug service.
 *
 * @generated from message thru.services.v1.DebugReExecuteResponse
 */
export type DebugReExecuteResponse = Message<"thru.services.v1.DebugReExecuteResponse"> & {
  /**
   * @generated from field: thru.core.v1.Transaction transaction = 1;
   */
  transaction?: Transaction | undefined;

  /**
   * @generated from field: string stdout = 2;
   */
  stdout: string;

  /**
   * @generated from field: string log = 3;
   */
  log: string;

  /**
   * @generated from field: string trace = 4;
   */
  trace: string;

  /**
   * @generated from field: thru.services.v1.VmExecutionDetails execution_details = 5;
   */
  executionDetails?: VmExecutionDetails | undefined;

  /**
   * @generated from field: repeated thru.services.v1.AccountSnapshot state_before = 6;
   */
  stateBefore: AccountSnapshot[];

  /**
   * @generated from field: repeated thru.services.v1.AccountSnapshot state_after = 7;
   */
  stateAfter: AccountSnapshot[];

  /**
   * @generated from field: repeated thru.services.v1.MemorySegment memory_segments = 8;
   */
  memorySegments: MemorySegment[];
};

/**
 * Describes the message thru.services.v1.DebugReExecuteResponse.
 * Use `create(DebugReExecuteResponseSchema)` to create a new message.
 */
export const DebugReExecuteResponseSchema: GenMessage<DebugReExecuteResponse> = /*@__PURE__*/
  messageDesc(file_thru_services_v1_debug_service, 6);

/**
 * VmFaultCode enumerates VM halt conditions.
 *
 * @generated from enum thru.services.v1.VmFaultCode
 */
export enum VmFaultCode {
  /**
   * No fault
   *
   * @generated from enum value: VM_FAULT_NONE = 0;
   */
  VM_FAULT_NONE = 0,

  /**
   * TN_VM_FAULT_REVERT — explicit revert by program
   *
   * @generated from enum value: VM_FAULT_REVERT = 1;
   */
  VM_FAULT_REVERT = 1,

  /**
   * TN_VM_FAULT_SIGCU  — compute units exhausted
   *
   * @generated from enum value: VM_FAULT_SIGCU = 2;
   */
  VM_FAULT_SIGCU = 2,

  /**
   * TN_VM_FAULT_SIGSU  — state units exhausted
   *
   * @generated from enum value: VM_FAULT_SIGSU = 3;
   */
  VM_FAULT_SIGSU = 3,
}

/**
 * Describes the enum thru.services.v1.VmFaultCode.
 */
export const VmFaultCodeSchema: GenEnum<VmFaultCode> = /*@__PURE__*/
  enumDesc(file_thru_services_v1_debug_service, 0);

/**
 * DebugService defines unary RPCs helpful for debugging.
 *
 * @generated from service thru.services.v1.DebugService
 */
export const DebugService: GenService<{
  /**
   * DebugReExecute executes a transaction in simulated environment.
   *
   * @generated from rpc thru.services.v1.DebugService.DebugReExecute
   */
  debugReExecute: {
    methodKind: "unary";
    input: typeof DebugReExecuteRequestSchema;
    output: typeof DebugReExecuteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_thru_services_v1_debug_service, 0);

